import axios from '@projectK/services/axios';

const routesWithOutAuth = [
  '/signin',
  '/signup',
  '/forget-password',
  '/reset-password',
  '/product-listing',
  '/reset-password/:token',
  '/invitation/activate/:token',
  '/widgets/products/:productSlug',
  '/widgets/packages/:packageSlug',
  '/widgets/tournament/:tournamentSlug',
  '/tournament-registration',
  '/tournaments',
];

const pathToRegex = (path) =>
  new RegExp(
    '^' +
      path
        .replace(/:[^/]+/g, '[^/]+') // replace :params with wildcard matchers
        .replace(/\//g, '\\/') + // escape slashes
      '$',
  );

const allowedRouteRegexes = routesWithOutAuth.map(pathToRegex);
const isRouteAllowed = (path) =>
  allowedRouteRegexes.some((regex) => regex.test(path));
const jwtAxios = axios?.create({
  // eslint-disable-next-line no-restricted-globals
  baseURL:
    location.host === 'localhost:4200' ? `http://localhost:5000/api` : '/api', //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});
jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.status === 401) {
      // Check if the current page is not already the sign-in page
      if (!isRouteAllowed(window.location.pathname)) {
        window.location.href = '/signin';
      }
    }
    return Promise.reject(err);
  },
);

export const setAuthToken = (token) => {
  // App auth is session-cookie based. Keep this only for cleanup compatibility.
  if (!token) {
    delete jwtAxios.defaults.headers.common['Authorization'];
    localStorage.removeItem('token');
    localStorage.removeItem('modalClosed');
  }
};

export default jwtAxios;
